export var compKey = 'notification-item';
//# sourceMappingURL=key.js.map